function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.42334 46.1004H20.2233V26.9004H9.42334V46.1004Z",
  fill: "#DD0060"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M90.2231 46.1004H108.223V26.9004H90.2231V46.1004Z",
  fill: "#DD0060"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.359 56.3064C16.981 42.6734 18.353 23.8724 30.475 11.7514C42.434 -0.208571 60.896 -1.70357 74.482 7.26643",
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M84.0875 16.6934C93.4655 30.3264 92.0935 49.1274 79.9725 61.2484C67.8505 73.3694 49.0505 74.7414 35.4175 65.3634",
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M44.9292 46.7941L65.5172 26.2061",
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "square"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M44.9292 26.2061L65.5172 46.7941",
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "square"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M90.2231 26.8994H108.223V46.0994H90.2231",
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5 46.1004H1.5V26.9004H20.5",
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M108.223 19.7002V53.3002",
  stroke: "black",
  strokeWidth: 3
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 19.7002V53.3002",
  stroke: "black",
  strokeWidth: 3
});

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 73,
    viewBox: "0 0 110 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.56de4dd5.svg";
export { ForwardRef as ReactComponent };